import { Link } from "gatsby";
import PageSection from "@components/PageSection";
import React from "react";
import SafeImage from "@components/SafeImage";
import { GetThumbnailImage } from "@services/ProductImages";

interface Props {
  noncolors: Queries.ProductFragment[];
}

const NonColors = ({ noncolors }: Props) => (
  <PageSection sectionName="Products">
    <div className="flex flex-wrap justify-center w-full gap-6">
        {noncolors
          .sort((a, b) =>
            (a?.item_parents?.[0]?.friendly_item_number ?? "zzzzz").localeCompare(b?.item_parents?.[0]?.friendly_item_number ?? "zzzzz"),
          )
          .map((p) => {
            const thumbnail = GetThumbnailImage(p);
            return (
              <Link to={`/products/${p.slug}`} key={p.product_name}  >
                <div className="flex flex-col items-center w-24" key={p.product_name}>
                  <SafeImage src={thumbnail?.fullImageUrl} alt={thumbnail?.altText} style={{ width: "100%" }} />
                  <p className="text-center underline">                  {p?.product_name ?? ""}                 </p>
                  <p className="text-sm text-slate-700 text-center">  {p.item_parents.map((ip) => `${ip.friendly_item_number} `)}                 </p>
                </div>
              </Link>
            );
          })}
     </div>
  </PageSection>
);

export default NonColors;
